import React, { useState, useEffect } from 'react';
import { db, auth } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';
import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import AdminDashboard from './AdminDashboard';
import AdminProducts from './AdminProducts';
import AdminOrders from './AdminOrders';
import AdminConsultations from './AdminConsultations';
import { FaHome, FaBox, FaShoppingCart, FaSignOutAlt, FaQuestionCircle } from 'react-icons/fa';
import '../Admin.css';

function Admin() {
  const [user, setUser] = useState(null);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [products, setProducts] = useState([]);
  const [orders, setOrders] = useState([]);
  const [consultations, setConsultations] = useState([]);
  const [currentPage, setCurrentPage] = useState('dashboard');

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setUser(user);
      if (user) {
        loadData();
      }
    });
    return unsubscribe;
  }, []);

  const loadData = async () => {
    await Promise.all([loadProducts(), loadOrders(), loadConsultations()]);
  };

  const loadProducts = async () => {
    const querySnapshot = await getDocs(collection(db, 'products'));
    const productsData = querySnapshot.docs.map(doc => {
      const data = doc.data();
      delete data.id;
      return { id: doc.id, ...data };
    });
    setProducts(productsData);
  };

  const loadOrders = async () => {
    const querySnapshot = await getDocs(collection(db, 'orders'));
    const ordersData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setOrders(ordersData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)));
  };

  const loadConsultations = async () => {
    const querySnapshot = await getDocs(collection(db, 'consultations'));
    const consultationsData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setConsultations(consultationsData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)));
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (error) {
      alert('Ошибка входа: ' + error.message);
    }
  };

  const handleLogout = () => {
    signOut(auth);
    setUser(null);
  };

  if (!user) {
    return (
      <div className="admin-login">
        <div className="login-card">
          <h2>Админ-панель</h2>
          <p>Дух Приморья</p>
          <form onSubmit={handleLogin}>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <input
              type="password"
              placeholder="Пароль"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button type="submit">Войти</button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-panel">
      <aside className="admin-sidebar">
        <div className="sidebar-header">
          <h2>Дух Приморья</h2>
          <p>Админ-панель</p>
        </div>
        <nav className="sidebar-nav">
          <button 
            className={currentPage === 'dashboard' ? 'active' : ''}
            onClick={() => setCurrentPage('dashboard')}
          >
            <FaHome /> Главная
          </button>
          <button 
            className={currentPage === 'products' ? 'active' : ''}
            onClick={() => setCurrentPage('products')}
          >
            <FaBox /> Товары
            <span className="nav-badge">{products.length}</span>
          </button>
          <button 
            className={currentPage === 'orders' ? 'active' : ''}
            onClick={() => setCurrentPage('orders')}
          >
            <FaShoppingCart /> Заказы
            {orders.filter(o => o.status === 'new').length > 0 && (
              <span className="nav-badge badge-alert">{orders.filter(o => o.status === 'new').length}</span>
            )}
          </button>
          <button 
            className={currentPage === 'consultations' ? 'active' : ''}
            onClick={() => setCurrentPage('consultations')}
          >
            <FaQuestionCircle /> Консультации
            {consultations.filter(c => c.status === 'new').length > 0 && (
              <span className="nav-badge badge-alert">{consultations.filter(c => c.status === 'new').length}</span>
            )}
          </button>
        </nav>
        <div className="sidebar-footer">
          <button onClick={handleLogout} className="btn-logout">
            <FaSignOutAlt /> Выйти
          </button>
        </div>
      </aside>

      <main className="admin-main">
        {currentPage === 'dashboard' && <AdminDashboard products={products} orders={orders} />}
        {currentPage === 'products' && <AdminProducts products={products} onUpdate={loadProducts} />}
        {currentPage === 'orders' && <AdminOrders orders={orders} onUpdate={loadOrders} />}
        {currentPage === 'consultations' && <AdminConsultations consultations={consultations} onUpdate={loadConsultations} />}
      </main>
    </div>
  );
}

export default Admin;
